enum DeductionLimitType {
  NO_LIMIT, PER_PAY_PERIOD, PER_YEAR
}

export default DeductionLimitType;
